export const DS_DEFAULT_PACK_NAME = 'default';
export const DS_ICON_GLOBAL_SVG_ID = 'ds-icon-list';
